/** Mirrors API CIRCATRON_SCOPE_PRESETS (connectors/meta.scope_presets). */

export const CIRCATRON_SCOPE_PRESETS = [
  {
    id: "channel_bot",
    label: "Channel bot",
    description: "Post to the bound channel",
    scopes: ["channel.post"],
  },
  {
    id: "support_coworker",
    label: "Support coworker",
    description: "Channel + team posts and kanban cards",
    scopes: [
      "channel.post",
      "posts.read.team",
      "posts.write.team",
      "kanban.update",
    ],
  },
  {
    id: "org_reader",
    label: "Org reader",
    description: "Read org feed and post to the bound channel",
    scopes: ["posts.read.org", "channel.post"],
  },
];

export function scopesForPreset(presetId) {
  const preset = CIRCATRON_SCOPE_PRESETS.find((p) => p.id === presetId);
  return preset ? [...preset.scopes] : null;
}

/** Infer which preset matches an exact scope set (order-independent). */
export function matchScopePreset(scopes) {
  const set = new Set(Array.isArray(scopes) ? scopes : []);
  for (const preset of CIRCATRON_SCOPE_PRESETS) {
    if (
      preset.scopes.length === set.size &&
      preset.scopes.every((s) => set.has(s))
    ) {
      return preset.id;
    }
  }
  return "custom";
}
